import React, { useContext } from 'react'
import { useState } from 'react';
import { useEffect } from 'react'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Link } from 'react-router-dom';
import Loading from '../loading/Loading';
import AppContext from "../../context/AppContext";
import { Container, Row } from 'reactstrap';

function HaberSlider({ adet = 3, baslik })
{
  const [contents, setContents] = useState([])
  const { mainPageNews } = useContext(AppContext);
  useEffect(() => {
    setContents(mainPageNews?.slice(0, adet));
  })

  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    lazyLoad: 'ondemand',
  };

  return (
    <>
      <Loading />
      <Container className='mt-4'>
        <div className="homeTitle">HABERLER</div>
              <div className="newsBox">
                <div className="row">

                <Slider {...settings}>
                  {
                    contents?.map((content, index) => (
                      <div className="col-md-4 news">
                        <Link to={`/content/${content?.uri}`}>
                          <div className="pcture"><img src={`https://content.samsun.edu.tr${content?.coverImageUrl}`}></img></div>
                          <div className="detail">
                            <span className="time"><i className="bi bi-calendar-check"></i>
                              {new Date(content?.atCreatedDate).toLocaleDateString("tr-TR")}
                            </span>
                            <span className="title">{content?.title}</span>
                            <span className="url">
                              Devamını oku<i className="bi bi-chevron-right"></i>
                            </span>
                          </div>
                        </Link>
                      </div>
                    ))
                    }
                  </Slider>
                </div>

                <div class="tumu mt-0">
                  <Link to="/haberler">Tüm haberler</Link>
                </div>
              </div>

      </Container>

    </>
  );
}

export default HaberSlider;